// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Baloo&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  :root {
  --main-bg-color: rgba(146,177,232,1);
  --fuente:  rgba(0, 0, 0,0.5);
}




.fondo_inv {

  bottom:20px;
  left: 20px;
  width: 100%;
  z-index: 6;
  position: absolute;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
}

.fondo_inv a {

  text-decoration: none;
  color: var(--main-bg-color);
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 20px;

}

.titulo_inv {

  top:20px;
  left: 20px;
  width: 90%;
  z-index: 6;
  position: absolute;
  color: black;
  display: flex;
  flex-direction: column;

  
}

.titulo_inv h1 {

  width: 100%;
  margin: 0;
  color: rgba(119,136,153,0.9);
  font-family: monospace;
  font-weight: bolder;
  font-size: 30px;
}

.titulo_inv span {

  width: 100%;
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 15px;
  font-style: italic;
  color: rgba(24, 1, 2,1.5);
}


.fondo_inventario {

  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: var(--main-bg-color);
  transition: all 1000ms ease-in-out;

}

.fil {

  width: 48%;
  height: 100%;

 display: flex;
 justify-content: center;

}


.fid {


  width: 49%;
  height: 100%;
  display: flex;
  flex-direction: column;

}

.fid .comentarios {

  position: relative;
  left: 25px;
  top:7em;
  margin-top:7em;
  width: 100%;
  height: auto;
  color: white;
  display: flex;
  flex-direction: column;
 
}

.fid .comentarios h1{

  font-family: monospace;
  font-size: 50px;
  font-weight: bolder;
  margin-bottom: 5px;

}

.fid .comentarios span{

  font-family: monospace;
  font-size: 20px;
  font-weight: bolder;
  

}

.fid .comentarios p{

  font-family: monospace;
  font-style: italic;
  font-size: 18px;
  font-weight: bolder;
  

}


.tag-wrap {
  width: 100%;
  height: 100%;
 filter:  drop-shadow(40px 20px 5px rgba(19, 19, 1, 0.1)); 

  /* -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.33);
  -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.33);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.33);  */
}

.wrap {
  display: inline-block;
  position: relative;

  width: 100%;
  height: 100%;
  background: white;
  justify-content: center;
  box-sizing: border-box; 
  clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 0 53%, 0% 0%);

}

.alert {

  position: absolute;
  left: 20px;
  bottom:50px;

}

.procesando {

  position: absolute;
  left: 20px;
  bottom:50px;
  width: 300px;
  height: auto;
  background-color: var(--main-bg-color);
  color: white;
  border-radius: 20px;
}

.wrap-login {

  position: absolute;
  top:6em;
  left: 3em;
  width: 75%;
  height:430px;
  /* border: 1px solid; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background-color: red; */

}

.wrap-login form {

  width: 100%;
  height: auto;

}

.login, .password {

  margin: 5px;
  padding: 5px;
  width: 70%;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 25px;
  font-weight: lighter;
  display: flex;
  flex-direction: column;

}

.botones {

  position: relative;
  padding: 3px;
  width:100%;
  height: 45px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 25px;
  font-weight: lighter;
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: left;

}

.botones input {

  margin-top: 30px;
  margin-bottom: 5px;
  cursor: pointer;
  border: 0px;
  height: 100%;
  width: 250px;
  background-color: var(--main-bg-color);
  color: white;
  font-family: monospace;
  font-size: 25px;
  font-weight: bold;
  border-radius: 20px;

}

.botones a {

 
  cursor: pointer;
  font-size: 25px;
  color: var(--main-bg-color);

}

.inputpass {

  
  position: relative;
  background-color: red;
  display: inline;
  width: 100%;
  padding: 0;
  margin: 0;
  
}

.inputpass input, .login input  {

  border: 0px;
  border-bottom: 1px solid;
 width: 100%;
  margin: 0;
  padding-right: 0;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 25px;
  font-weight: lighter;
 
}

.inputpass input:focus, .login input:focus {

  background-color: var(--main-bg-color);
  color: white;

}

.inputpass span  {

  height: 100%;
  width: 30px;
  position: absolute;
  cursor: pointer;
  top:7px;
  
  right: 0;
  margin: 0;
  padding: 0;
 
  /* background-color: var(--main-bg-color);
  color: white;
  text-align: center; */
 
  
}

.imagen {

  margin: 0px;
  position: absolute  ;
 
  text-align: center;
  bottom: 20px;
  right: 20px;
  width: 350px;
  height: auto;


}

img {

  width: 100%;
  height: auto;
  object-fit: cover;
  
}

.titulos_index {

  z-index: 7;
  width: 100%;
  height: auto;
  position: relative;
  top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 0px;

}

.items {

  width: auto;
  height: 100%;
  margin-right: 50px;  
  display: flex;
  flex-direction: column;
  justify-content: center;

}


.titulos_index .items a{

  text-decoration: none;
  cursor: pointer;
  color: white;
  font-size: 20px;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-weight: bolder;
}


/*AGREGADO DE LA VERSION ANTERIOR*/

.nuevo {

  z-index: 8;
  position: fixed;
  top: 0px;
  right:0px;
  height: 100%;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.8);
}

.nuevo .seleccion{

  
  position: absolute;
  background-color:white;
  top:0px;
  right: 0px;
  width: 90%;
  height: 100vh;

}

.items-seleccion {

  padding-top:10px;
  padding-bottom: 40px;
  width: 100%;
  height: 100%;
  overflow: auto;
  
}

.nuevo .pie {


  bottom: 10px;
  margin-bottom: 20px;
  text-align: center;

}

/*@GOOGLE*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}

.btn-google {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.md-24 {

  font-size: 24px;

}

.md-36 {

  font-size: 36px;

}

.md-48 {

  font-size: 48px;

}

/*@GOOGLE*/



/*AGREGADO DE LA VERSION ANTERIOR*/

@media only screen and (min-width: 1024px) {

 

      /* rgba(255,179,71,1); */
      .fondo_inventario {
          
          --main-bg-color: rgba(254,199,205,255);
           /* background-color: rgba(254,199,205,255);  */
          
      }


       /*PINK*/

      .fid .comentarios {

          
          top: 3em;
          margin-top: 3em;
      
      }

      
      
      
      
  }
  
  /* Largest devices such as desktops (1280px and up) */
  @media only screen and (min-width: 1280px) {
      
      .fondo_inventario {
          
          /* rgba(255,179,71,1); */
          --main-bg-color: rgba(146,177,232,255);
          
      }

      .botones {
  
        width: 90%;
      
      }
      
      
  }
  
  /* Default: Large devices such as laptops, computers (greater than 1024px) *
  
  /* Medium devices such as tablets (1024px or lesser) */
  @media only screen and (max-width: 1024px) {
      
      
    .fondo_inventario {
          
          /* rgba(255,179,71,1); */
          /* background-color:    rgba(244, 91, 105, 1); */
          --main-bg-color: rgba(119,136,153,0.5);
          /* background-color: rgba(119,136,153,0.5); */
          
      }

      .wrap-login {

     
          top:4em;
          
      
      }

      .botones {
  
        width: 100%;
      
      }

      .fid .comentarios {

       
          top: 3em;
          margin-top: 3em;
       
      
      }
      
}

/* Small devices such as phones (768px or lesser) */
@media only screen and (max-width: 768px) {
  
  
    
    
    .fondo_inventario { 
      
      
      width: 100%;
      height: auto;
      --main-bg-color:  rgba(244, 91, 105, 1);
      
      flex-direction: column;

  }

  .fil {

    
      width: 95%;
      height: 100vh;
      padding-bottom: 20px;
  
  }
  
  
  .fid {
  
      width: 95%;
      height: 100vh;
     
  
  }

  /*ROJO*/

  .botones {
  
    width: 96%;
  
  }
  .fid .comentarios {

          
      top: 4em;
      margin-top: 4em;
  
  
  }

  .imagen {

      width: 40%;

  }

  .wrap-login {

     
      top:4em;
      
  
  }
}`, "",{"version":3,"sources":["webpack://./src/app/login/login.component.css"],"names":[],"mappings":";EAMA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;;;;AAKA;;EAEE,WAAW;EACX,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,qGAAqG;EACrG,eAAe;;AAEjB;;AAEA;;EAEE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;;;AAGxB;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,4DAA4D;EAC5D,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;;AAEpC;;AAEA;;EAEE,UAAU;EACV,YAAY;;CAEb,aAAa;CACb,uBAAuB;;AAExB;;;AAGA;;;EAGE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;;AAExB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;;AAExB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;;;AAGrB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;;;AAGrB;;;AAGA;EACE,WAAW;EACX,YAAY;CACb,wDAAwD;;EAEvD;;oDAEkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;;EAElB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EAEtB,qEAAqE;;AAEvE;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;;AAEb;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;;AAE7B;;AAEA;;EAEE,WAAW;EACX,YAAY;;AAEd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sHAAsH;EACtH,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;;AAExB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,sHAAsH;EACtH,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;;AAEnB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;;AAErB;;AAEA;;;EAGE,eAAe;EACf,eAAe;EACf,2BAA2B;;AAE7B;;AAEA;;;EAGE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,UAAU;EACV,SAAS;;AAEX;;AAEA;;EAEE,WAAW;EACX,wBAAwB;CACzB,WAAW;EACV,SAAS;EACT,gBAAgB;EAChB,sHAAsH;EACtH,eAAe;EACf,oBAAoB;;AAEtB;;AAEA;;EAEE,sCAAsC;EACtC,YAAY;;AAEd;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,OAAO;;EAEP,QAAQ;EACR,SAAS;EACT,UAAU;;EAEV;;uBAEqB;;;AAGvB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;;EAEpB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;;;AAGd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;;AAEnB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;AAEjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;AAEzB;;;AAGA;;EAEE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,wEAAwE;EACxE,mBAAmB;AACrB;;;AAGA,kCAAkC;;AAElC;;EAEE,UAAU;EACV,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,UAAU;EACV,UAAU;EACV,aAAa;;AAEf;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;;AAEhB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA,UAAU;AACV;EACE,eAAe;EACf;;;;;AAKF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA,UAAU;;;;AAIV,kCAAkC;;AAElC;;;;MAIM,wBAAwB;MACxB;;UAEI,sCAAsC;WACrC,8CAA8C;;MAEnD;;;OAGC,OAAO;;MAER;;;UAGI,QAAQ;UACR,eAAe;;MAEnB;;;;;;EAMJ;;EAEA,qDAAqD;EACrD;;MAEI;;UAEI,wBAAwB;UACxB,sCAAsC;;MAE1C;;MAEA;;QAEE,UAAU;;MAEZ;;;EAGJ;;EAEA;;wDAEsD;EACtD;;;IAGE;;UAEM,wBAAwB;UACxB,gDAAgD;UAChD,sCAAsC;UACtC,6CAA6C;;MAEjD;;MAEA;;;UAGI,OAAO;;;MAGX;;MAEA;;QAEE,WAAW;;MAEb;;MAEA;;;UAGI,QAAQ;UACR,eAAe;;;MAGnB;;AAEN;;AAEA,mDAAmD;AACnD;;;;;IAKI;;;MAGE,WAAW;MACX,YAAY;MACZ,uCAAuC;;MAEvC,sBAAsB;;EAE1B;;EAEA;;;MAGI,UAAU;MACV,aAAa;MACb,oBAAoB;;EAExB;;;EAGA;;MAEI,UAAU;MACV,aAAa;;;EAGjB;;EAEA,OAAO;;EAEP;;IAEE,UAAU;;EAEZ;EACA;;;MAGI,QAAQ;MACR,eAAe;;;EAGnB;;EAEA;;MAEI,UAAU;;EAEd;;EAEA;;;MAGI,OAAO;;;EAGX;AACF","sourcesContent":["\r\n  @import url('https://fonts.googleapis.com/css?family=Baloo&display=swap');\r\n  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');\r\n\r\n\r\n  \r\n:root {\r\n  --main-bg-color: rgba(146,177,232,1);\r\n  --fuente:  rgba(0, 0, 0,0.5);\r\n}\r\n\r\n\r\n\r\n\r\n.fondo_inv {\r\n\r\n  bottom:20px;\r\n  left: 20px;\r\n  width: 100%;\r\n  z-index: 6;\r\n  position: absolute;\r\n  color: black;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  \r\n}\r\n\r\n.fondo_inv a {\r\n\r\n  text-decoration: none;\r\n  color: var(--main-bg-color);\r\n  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;\r\n  font-size: 20px;\r\n\r\n}\r\n\r\n.titulo_inv {\r\n\r\n  top:20px;\r\n  left: 20px;\r\n  width: 90%;\r\n  z-index: 6;\r\n  position: absolute;\r\n  color: black;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  \r\n}\r\n\r\n.titulo_inv h1 {\r\n\r\n  width: 100%;\r\n  margin: 0;\r\n  color: rgba(119,136,153,0.9);\r\n  font-family: monospace;\r\n  font-weight: bolder;\r\n  font-size: 30px;\r\n}\r\n\r\n.titulo_inv span {\r\n\r\n  width: 100%;\r\n  margin: 0;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 15px;\r\n  font-style: italic;\r\n  color: rgba(24, 1, 2,1.5);\r\n}\r\n\r\n\r\n.fondo_inventario {\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  background-color: var(--main-bg-color);\r\n  transition: all 1000ms ease-in-out;\r\n\r\n}\r\n\r\n.fil {\r\n\r\n  width: 48%;\r\n  height: 100%;\r\n\r\n display: flex;\r\n justify-content: center;\r\n\r\n}\r\n\r\n\r\n.fid {\r\n\r\n\r\n  width: 49%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n.fid .comentarios {\r\n\r\n  position: relative;\r\n  left: 25px;\r\n  top:7em;\r\n  margin-top:7em;\r\n  width: 100%;\r\n  height: auto;\r\n  color: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n \r\n}\r\n\r\n.fid .comentarios h1{\r\n\r\n  font-family: monospace;\r\n  font-size: 50px;\r\n  font-weight: bolder;\r\n  margin-bottom: 5px;\r\n\r\n}\r\n\r\n.fid .comentarios span{\r\n\r\n  font-family: monospace;\r\n  font-size: 20px;\r\n  font-weight: bolder;\r\n  \r\n\r\n}\r\n\r\n.fid .comentarios p{\r\n\r\n  font-family: monospace;\r\n  font-style: italic;\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n  \r\n\r\n}\r\n\r\n\r\n.tag-wrap {\r\n  width: 100%;\r\n  height: 100%;\r\n filter:  drop-shadow(40px 20px 5px rgba(19, 19, 1, 0.1)); \r\n\r\n  /* -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.33);\r\n  -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.33);\r\n  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.33);  */\r\n}\r\n\r\n.wrap {\r\n  display: inline-block;\r\n  position: relative;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n  background: white;\r\n  justify-content: center;\r\n  box-sizing: border-box;\r\n  -webkit-clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 0 53%, 0% 0%); \r\n  clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 0 53%, 0% 0%);\r\n\r\n}\r\n\r\n.alert {\r\n\r\n  position: absolute;\r\n  left: 20px;\r\n  bottom:50px;\r\n\r\n}\r\n\r\n.procesando {\r\n\r\n  position: absolute;\r\n  left: 20px;\r\n  bottom:50px;\r\n  width: 300px;\r\n  height: auto;\r\n  background-color: var(--main-bg-color);\r\n  color: white;\r\n  border-radius: 20px;\r\n}\r\n\r\n.wrap-login {\r\n\r\n  position: absolute;\r\n  top:6em;\r\n  left: 3em;\r\n  width: 75%;\r\n  height:430px;\r\n  /* border: 1px solid; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* background-color: red; */\r\n\r\n}\r\n\r\n.wrap-login form {\r\n\r\n  width: 100%;\r\n  height: auto;\r\n\r\n}\r\n\r\n.login, .password {\r\n\r\n  margin: 5px;\r\n  padding: 5px;\r\n  width: 70%;\r\n  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\r\n  font-size: 25px;\r\n  font-weight: lighter;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n.botones {\r\n\r\n  position: relative;\r\n  padding: 3px;\r\n  width:100%;\r\n  height: 45px;\r\n  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\r\n  font-size: 25px;\r\n  font-weight: lighter;\r\n  display: flex;\r\n  flex-direction:column;\r\n  justify-content: center;\r\n  align-items: left;\r\n\r\n}\r\n\r\n.botones input {\r\n\r\n  margin-top: 30px;\r\n  margin-bottom: 5px;\r\n  cursor: pointer;\r\n  border: 0px;\r\n  height: 100%;\r\n  width: 250px;\r\n  background-color: var(--main-bg-color);\r\n  color: white;\r\n  font-family: monospace;\r\n  font-size: 25px;\r\n  font-weight: bold;\r\n  border-radius: 20px;\r\n\r\n}\r\n\r\n.botones a {\r\n\r\n \r\n  cursor: pointer;\r\n  font-size: 25px;\r\n  color: var(--main-bg-color);\r\n\r\n}\r\n\r\n.inputpass {\r\n\r\n  \r\n  position: relative;\r\n  background-color: red;\r\n  display: inline;\r\n  width: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  \r\n}\r\n\r\n.inputpass input, .login input  {\r\n\r\n  border: 0px;\r\n  border-bottom: 1px solid;\r\n width: 100%;\r\n  margin: 0;\r\n  padding-right: 0;\r\n  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\r\n  font-size: 25px;\r\n  font-weight: lighter;\r\n \r\n}\r\n\r\n.inputpass input:focus, .login input:focus {\r\n\r\n  background-color: var(--main-bg-color);\r\n  color: white;\r\n\r\n}\r\n\r\n.inputpass span  {\r\n\r\n  height: 100%;\r\n  width: 30px;\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top:7px;\r\n  \r\n  right: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n \r\n  /* background-color: var(--main-bg-color);\r\n  color: white;\r\n  text-align: center; */\r\n \r\n  \r\n}\r\n\r\n.imagen {\r\n\r\n  margin: 0px;\r\n  position: absolute  ;\r\n \r\n  text-align: center;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  width: 350px;\r\n  height: auto;\r\n\r\n\r\n}\r\n\r\nimg {\r\n\r\n  width: 100%;\r\n  height: auto;\r\n  object-fit: cover;\r\n  \r\n}\r\n\r\n.titulos_index {\r\n\r\n  z-index: 7;\r\n  width: 100%;\r\n  height: auto;\r\n  position: relative;\r\n  top: 20px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  margin-top: 0px;\r\n\r\n}\r\n\r\n.items {\r\n\r\n  width: auto;\r\n  height: 100%;\r\n  margin-right: 50px;  \r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n\r\n}\r\n\r\n\r\n.titulos_index .items a{\r\n\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  color: white;\r\n  font-size: 20px;\r\n  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;\r\n  font-weight: bolder;\r\n}\r\n\r\n\r\n/*AGREGADO DE LA VERSION ANTERIOR*/\r\n\r\n.nuevo {\r\n\r\n  z-index: 8;\r\n  position: fixed;\r\n  top: 0px;\r\n  right:0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  background-color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: rgba(0,0,0,0.8);\r\n}\r\n\r\n.nuevo .seleccion{\r\n\r\n  \r\n  position: absolute;\r\n  background-color:white;\r\n  top:0px;\r\n  right: 0px;\r\n  width: 90%;\r\n  height: 100vh;\r\n\r\n}\r\n\r\n.items-seleccion {\r\n\r\n  padding-top:10px;\r\n  padding-bottom: 40px;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  \r\n}\r\n\r\n.nuevo .pie {\r\n\r\n\r\n  bottom: 10px;\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n\r\n}\r\n\r\n/*@GOOGLE*/\r\n.material-symbols-outlined {\r\n  cursor: pointer;\r\n  font-variation-settings:\r\n  'FILL' 0,\r\n  'wght' 400,\r\n  'GRAD' 0,\r\n  'opsz' 24\r\n}\r\n\r\n.btn-google {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.md-24 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-36 {\r\n\r\n  font-size: 36px;\r\n\r\n}\r\n\r\n.md-48 {\r\n\r\n  font-size: 48px;\r\n\r\n}\r\n\r\n/*@GOOGLE*/\r\n\r\n\r\n\r\n/*AGREGADO DE LA VERSION ANTERIOR*/\r\n\r\n@media only screen and (min-width: 1024px) {\r\n\r\n \r\n\r\n      /* rgba(255,179,71,1); */\r\n      .fondo_inventario {\r\n          \r\n          --main-bg-color: rgba(254,199,205,255);\r\n           /* background-color: rgba(254,199,205,255);  */\r\n          \r\n      }\r\n\r\n\r\n       /*PINK*/\r\n\r\n      .fid .comentarios {\r\n\r\n          \r\n          top: 3em;\r\n          margin-top: 3em;\r\n      \r\n      }\r\n\r\n      \r\n      \r\n      \r\n      \r\n  }\r\n  \r\n  /* Largest devices such as desktops (1280px and up) */\r\n  @media only screen and (min-width: 1280px) {\r\n      \r\n      .fondo_inventario {\r\n          \r\n          /* rgba(255,179,71,1); */\r\n          --main-bg-color: rgba(146,177,232,255);\r\n          \r\n      }\r\n\r\n      .botones {\r\n  \r\n        width: 90%;\r\n      \r\n      }\r\n      \r\n      \r\n  }\r\n  \r\n  /* Default: Large devices such as laptops, computers (greater than 1024px) *\r\n  \r\n  /* Medium devices such as tablets (1024px or lesser) */\r\n  @media only screen and (max-width: 1024px) {\r\n      \r\n      \r\n    .fondo_inventario {\r\n          \r\n          /* rgba(255,179,71,1); */\r\n          /* background-color:    rgba(244, 91, 105, 1); */\r\n          --main-bg-color: rgba(119,136,153,0.5);\r\n          /* background-color: rgba(119,136,153,0.5); */\r\n          \r\n      }\r\n\r\n      .wrap-login {\r\n\r\n     \r\n          top:4em;\r\n          \r\n      \r\n      }\r\n\r\n      .botones {\r\n  \r\n        width: 100%;\r\n      \r\n      }\r\n\r\n      .fid .comentarios {\r\n\r\n       \r\n          top: 3em;\r\n          margin-top: 3em;\r\n       \r\n      \r\n      }\r\n      \r\n}\r\n\r\n/* Small devices such as phones (768px or lesser) */\r\n@media only screen and (max-width: 768px) {\r\n  \r\n  \r\n    \r\n    \r\n    .fondo_inventario { \r\n      \r\n      \r\n      width: 100%;\r\n      height: auto;\r\n      --main-bg-color:  rgba(244, 91, 105, 1);\r\n      \r\n      flex-direction: column;\r\n\r\n  }\r\n\r\n  .fil {\r\n\r\n    \r\n      width: 95%;\r\n      height: 100vh;\r\n      padding-bottom: 20px;\r\n  \r\n  }\r\n  \r\n  \r\n  .fid {\r\n  \r\n      width: 95%;\r\n      height: 100vh;\r\n     \r\n  \r\n  }\r\n\r\n  /*ROJO*/\r\n\r\n  .botones {\r\n  \r\n    width: 96%;\r\n  \r\n  }\r\n  .fid .comentarios {\r\n\r\n          \r\n      top: 4em;\r\n      margin-top: 4em;\r\n  \r\n  \r\n  }\r\n\r\n  .imagen {\r\n\r\n      width: 40%;\r\n\r\n  }\r\n\r\n  .wrap-login {\r\n\r\n     \r\n      top:4em;\r\n      \r\n  \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
